import React, { useContext } from 'react';
import { AnimationBlockerView } from '@bingads-webui-campaign-react/pmax-lite-wizard';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import bingAdsIcon from './bing-ads-icon.png';

const getStyles = () => ({
  sdkNormalBlocker: {
    '&.animation-blocker': {
      background: '#fff',
      '& .processing-animation-container': {
        boxShadow: 'none',
      },
    },
    '& .animation-description': {
      fontSize: 14,
    },
    '& .animation-container .ms-Label': {
      fontSize: 12,
    },
  },
  header: {
    display: 'block',
    textAlign: 'center',
    '& h1': {
      margin: '8px 0',
      fontSize: 20,
      lineHeight: '28px',
    },
  },
  bingAdsIcon: {
    width: 36,
    height: 32,
  },
});

export const SDKNormalBlocker = () => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <AnimationBlockerView
      className={classes.sdkNormalBlocker}
      title={(
        <div className={classes.header}>
          <img className={classes.bingAdsIcon} src={bingAdsIcon} alt={i18n.getString(_TL_('Microsoft Advertising icon'))} />
          <h1>{i18n.getString(_TL_('Checking your website'))}</h1>
        </div>
      )}
      description={i18n.getString(_TL_('We\'ll use your website content to customize your campaign setup and suggest settings to help you get your desired results.'))}
      rollingTexts={[
        i18n.getString(_TL_('Please wait while we crawl your website.')),
        i18n.getString(_TL_('Almost ready...')),
      ]}
      showIcon={false}
      useProgressIndicator={false}
    />
  );
};
